<script lang='ts'>

    // CASSIOPEIA
    import { SubscriptionItem } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import Title from 'src/app/library/title/Title.svelte';
    import SubscriptionListPage from './pages/list/SubscriptionListPage.svelte';
    import SubscriptionFormPage from './pages/form/SubscriptionFormPage.svelte';

    // PLUGINS
    import { Router, Route } from 'svelte-navigator';

</script>

<Title title = 'Subscriptions' />

<Router>

    <Route path = ':key' let:params>
        <!-- TODO: Fix type handling on slots / routes -->
        <!-- eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -->
         <SubscriptionItem key = { params.key } let:subscription>
            <SubscriptionFormPage { subscription } action = 'update'/>
        </SubscriptionItem>
    </Route>

    <Route path = 'create'>
        <SubscriptionFormPage action = 'create' />
    </Route>

    <Route path = '/'>
        <SubscriptionListPage />
    </Route>

</Router>